module.exports = __webpack_public_path__ + "static/media/monitor1.c4280095.svg";